import React from "react"

// Img
import imgKawasaki from "../../assets/img/logo_kawasaki.png"

const LogoKawasaki = () => {
  return <img src={imgKawasaki} alt="Kawasaki Powering your potential" />
}

export default LogoKawasaki